import type { MessageSchema } from "./zh";

const messages: MessageSchema = {
  common: {
    appName: "Jzbro Cloud",
    appNameGlobal: "Starparks",
    confirm: "Đồng ý",
    cancel: "Hủy",
    loginRegister: "Đăng nhập / Đăng ký",
    userAgreement: "Điều khoản dịch vụ",
    privacyPolicy: "Chính sách bảo mật",
    notBound: "Chưa liên kết",
  },
  tabbar: {
    home: "Trang chủ",
    search: "Tìm kiếm",
    library: "Thư viện",
    mine: "Tôi",
    badgeLogin: "Đăng nhập",
    badgeUpgrade: "VIP",
  },
  login: {
    navTitle: "Đăng nhập",
    welcome: "Chào mừng đến với {brand}",
    subtitle: "Đăng nhập bằng SMS, hoặc dùng WeChat / QQ",
    subtitleGlobal: "Chơi ngay với tư cách khách, hoặc đăng nhập bằng Google / Telegram / Facebook",
    mobileLabel: "Số điện thoại",
    mobilePlaceholder: "Số điện thoại",
    codeLabel: "Mã",
    codePlaceholder: "Mã xác nhận",
    getCode: "Nhận mã",
    resendIn: "Gửi lại sau {sec}s",
    agreement:
      "Số chưa đăng ký sẽ tự động tạo tài khoản. Khi tiếp tục, bạn đồng ý với {userAgreement} và {privacyPolicy}",
    otherMethods: "Phương thức đăng nhập khác",
    guest: "Tiếp tục với tư cách khách",
    wechat: "Đăng nhập bằng WeChat",
    qq: "Đăng nhập bằng QQ",
    google: "Tiếp tục với Google",
    telegram: "Continue with Telegram",
    facebook: "Tiếp tục với Facebook",
    wechatComingSoon: "Đăng nhập WeChat sắp ra mắt",
    qqComingSoon: "Đăng nhập QQ sắp ra mắt",
    googleComingSoon: "Đăng nhập Google sắp ra mắt",
    googleFailed: "Đăng nhập Google thất bại, vui lòng thử lại",
    telegramFailed: "Telegram login failed, please try again",
    facebookComingSoon: "Đăng nhập Facebook sắp ra mắt",
    mobileInvalid: "Vui lòng nhập số điện thoại hợp lệ",
    codeInvalid: "Vui lòng nhập mã xác nhận",
    codeSent: "Đã gửi mã",
  },
  loginPrompt: {
    defaultMessage: "Đăng nhập để xem game của bạn",
  },
  settings: {
    navTitle: "Cài đặt",
    loginPrompt: "Đăng nhập để quản lý cài đặt tài khoản",
    nickname: "Biệt danh",
    mobile: "Số điện thoại",
    controller: "Cài đặt tay cầm",
    controllerDesc: "Độ nhạy chuột / cần phải / hoán đổi nút",
    about: "Giới thiệu",
    clearCache: "Xóa bộ nhớ đệm",
    language: "Ngôn ngữ",
    editNickname: "Sửa biệt danh",
    nicknamePlaceholder: "Biệt danh mới",
    nickEmpty: "Biệt danh không được để trống",
    nickTooLong: "Biệt danh tối đa 16 ký tự",
    updated: "Đã cập nhật",
    cacheCleared: "Đã xóa. Vui lòng đăng nhập lại",
    aboutTitle: "Giới thiệu {brand}",
    aboutVersion: "Phiên bản web v{version}",
    aboutBody:
      "Chơi game đám mây bom tấn AAA ngay trên trình duyệt, mọi lúc mọi nơi.\nMọi nội dung game thuộc bản quyền của nhà phát hành tương ứng.",
  },
  subscription: {
    choosePlan: "Chọn gói",
    included: "Bao gồm những gì",
    orderSummary: "Tóm tắt đơn hàng",
    total: "Tổng cộng",
    continue: "Tiếp tục",
    secureNote: "Thanh toán an toàn · Mua một lần",
    navTitle: "Nâng cấp",
    unlockTitle: "Mở khóa đặc quyền hội viên",
    expired: "Đã hết hạn",
    daysLeft: "Còn {days} ngày",
    validUntil: "Hiệu lực đến {time}",
    tagline: "Không xếp hàng, chơi lâu hơn, chất lượng cao hơn",
    perDay: "Khoảng {price}/ngày",
    recommended: "Đáng giá nhất",
    currentLevel: "Gói hiện tại",
    footer:
      "Đây là gói hội viên mua một lần. Thời hạn đã chọn sẽ được cộng sau khi thanh toán được xác nhận và sẽ không tự động gia hạn.",
    planVipMonth: "VIP theo tháng",
    planSvipMonth: "SVIP theo tháng",
    perkNoQueue: "Miễn xếp hàng",
    perkDailyFree: "60 phút miễn phí mỗi ngày",
    perkHd: "Chất lượng HD",
    perkAllVip: "Toàn bộ đặc quyền VIP",
    perkUnlimited: "Chơi không giới hạn thời gian",
    perk4k: "4K / 60fps",
    perkSupport: "Hỗ trợ ưu tiên",
    cnPayComingSoon:
      "Thanh toán WeChat / Alipay trên web sắp ra mắt — vui lòng dùng app trong lúc này",
    intlPayComingSoon: "Thanh toán Stripe / PayPal sắp ra mắt",
    payProcessing: "Hoàn tất thanh toán và giữ trang này mở…",
    paySuccess: "Thanh toán thành công — đã kích hoạt hội viên",
    payFailed: "Thanh toán thất bại, vui lòng thử lại",
    payCancelled: "Đã hủy thanh toán",
    telegramExtraTimeUnavailable: "Mua thời gian chơi trong Telegram sẽ khả dụng sau khi phiên bản Stars được bổ sung.",
    payUnconfirmed:
      "Chưa xác nhận thanh toán; nếu đã thanh toán, sẽ sớm được ghi nhận",
    payPopupBlocked:
      "Cửa sổ thanh toán đã bị chặn — vui lòng cho phép cửa sổ bật lên rồi thử lại",
    loadPlansFailed: "Tải gói thất bại, vui lòng thử lại",
    retry: "Thử lại",
  },
  app: {
    backToDesktop: "Về bản máy tính",
  },
  titles: {
    home: "Trang chủ",
    search: "Tìm kiếm",
    detail: "Chi tiết game",
    library: "Thư viện",
    category: "Danh mục",
    mine: "Tôi",
    myGames: "Game của tôi",
    reviews: "Đánh giá",
    gameVideos: "Video gameplay",
    commentReplies: "Bình luận",
    saves: "Bản lưu",
    subscription: "Nâng cấp",
    signIn: "Điểm danh hằng ngày",
    settings: "Cài đặt",
    controlSettings: "Cài đặt tay cầm",
    login: "Đăng nhập",
    play: "Đang chơi",
  },
  home: {
    searchPlaceholder: "Tìm game",
    sectionDefault: "Game",
    allGames: "Tất cả game",
    more: "Xem thêm",
    empty: "Chưa có gì ở đây",
    latestOnline: "Mới ra mắt",
    comingSoon: "Sắp ra mắt",
    subscribe: "Thông báo cho tôi",
    subscribed: "Đã đặt trước",
    score: "Điểm",
    subscribeSuccess: "Đã đặt trước — sẽ thông báo khi ra mắt",
  },
  nav: {
    home: "Trang chủ",
    library: "Thư viện",
    searchPlaceholder: "Tìm game",
    me: "Tôi",
    guest: "Khách",
    profile: "Hồ sơ",
    myGames: "Game của tôi",
    dailyCheckIn: "Điểm danh hằng ngày",
    renewMembership: "Gia hạn hội viên",
    upgradeMembership: "Nâng cấp hội viên",
    settings: "Cài đặt",
    switchToMobile: "Chuyển sang bản di động",
    logout: "Đăng xuất",
    logoutConfirm: "Bạn có chắc muốn đăng xuất?",
    mobileVersion: "Di động",
    login: "Đăng nhập",
  },
  library: {
    all: "Tất cả",
    noMore: "Đã hết",
    loading: "Đang tải…",
    noData: "Không có dữ liệu",
    noGames: "Không có game",
    noUpcoming: "Không có game sắp ra mắt",
    emptyCategory: "Danh mục này chưa có game",
  },
  mine: {
    notLoggedIn: "Chưa đăng nhập",
    loginSyncTip: "Đăng nhập để đồng bộ hội viên, yêu thích và lịch sử chơi",
    loginSyncTipDesktop:
      "Đăng nhập để xem hồ sơ, hội viên, điểm danh và lịch sử chơi",
    guest: "Khách",
    daysLeft: "Còn {n} ngày",
    expired: "Đã hết hạn",
    renewBanner: "{level} của bạn hết hạn sau {n} ngày — gia hạn giảm 30%",
    membershipExpiredRenew: "Hội viên đã hết hạn — gia hạn ngay",
    membershipExpired: "Hội viên đã hết hạn",
    membershipDaysLeft: "Còn {n} ngày hội viên",
    gameTime: "Thời gian chơi",
    minUnit: "phút",
    dailyCheckIn: "Điểm danh hằng ngày",
    upgrade: "Nâng cấp",
    renew: "Gia hạn",
    upgradeMembership: "Nâng cấp hội viên",
    renewMembership: "Gia hạn hội viên",
    membership: "Hội viên",
    myCollection: "Game yêu thích",
    collectedGames: "Game đã lưu",
    recentlyPlayed: "Chơi gần đây",
    gameHistory: "Lịch sử chơi",
    settings: "Cài đặt",
    switchToDesktop: "Chuyển sang bản máy tính",
    accountAndPrefs: "Tài khoản & tùy chọn",
    claimGameTime: "Nhận thời gian chơi",
    bindPhone: "Liên kết số điện thoại",
    bindPhoneDesc: "Nâng lên tài khoản chính thức và đồng bộ trên các thiết bị",
    bindPhoneDescDesktop: "Nâng lên tài khoản chính thức, đồng bộ trên các thiết bị",
    resetGuest: "Đặt lại tài khoản khách",
    resetGuestDesc: "Xóa tài khoản khách này và bắt đầu lại",
    resetGuestDescDesktop: "Bắt đầu lại với danh tính mới",
    logout: "Đăng xuất",
    myGamesTitle: "Game của tôi",
    collectTab: "Yêu thích",
    loginViewCollect: "Đăng nhập để xem game đã lưu",
    noCollect: "Chưa lưu game nào",
    loginViewHistory: "Đăng nhập để xem lịch sử chơi",
    noHistory: "Chưa chơi game nào gần đây",
    weekMon: "T2",
    weekTue: "T3",
    weekWed: "T4",
    weekThu: "T5",
    weekFri: "T6",
    weekSat: "T7",
    weekSun: "CN",
    alreadySignedToday: "Hôm nay đã điểm danh",
    signSuccessReward: "Điểm danh thành công! +{n} phút",
    signSuccess: "Đã điểm danh",
    loginJoinCheckIn: "Đăng nhập để điểm danh hằng ngày",
    claimed: "Đã nhận",
    unclaimed: "Bỏ lỡ",
    todayDone: "Hôm nay ✓",
    today: "Hôm nay",
    dayN: "Ngày {n}",
    signedToday: "Hôm nay đã điểm danh",
    signNow: "Điểm danh ngay",
    checkInTip1: "Điểm danh mỗi ngày để nhận thời gian chơi miễn phí.",
    checkInTip2: "Ngày bị bỏ lỡ có thể điểm danh bù bằng xu ở trang điểm danh bù.",
    loggedOut: "Đã đăng xuất",
    resetGuestConfirm:
      "Thao tác này sẽ xóa tài khoản khách hiện tại và bắt đầu lại với danh tính mới. Gói đăng ký, mục yêu thích và lịch sử đã mua sẽ mất hết. Tiếp tục?",
    resetGuestConfirmBtn: "Đặt lại",
    resetting: "Đang đặt lại…",
    resetDone: "Đã đặt lại — vui lòng đăng nhập lại",
  },
  reviews: {
    recommendRate: "đề xuất",
    tooFew: "Còn ít đánh giá",
    count: "{n} đánh giá",
    playFirst: "Chơi thử để viết đánh giá",
    rateThis: "Đã chơi? Hãy đánh giá",
    mine: "Của tôi",
    edit: "Sửa",
    delete: "Xóa",
    report: "Báo cáo",
    played: "Đã chơi {d}",
    contentEmpty: "Nội dung không được để trống",
    editReview: "Sửa đánh giá",
    editDone: "Đã cập nhật",
    published: "Đã đăng đánh giá",
    deleteTitle: "Xóa đánh giá?",
    deleteConfirm: "Không thể hoàn tác. Xóa đánh giá này?",
    deleted: "Đã xóa",
    reportTitle: "Báo cáo",
    reportConfirm: "Báo cáo nội dung này? Đội ngũ sẽ xem xét.",
    reported: "Đã báo cáo",
    deleteReplyTitle: "Xóa trả lời?",
    deleteReplyConfirm: "Xóa trả lời này?",
    replyTo: "đã trả lời",
    viewAllReplies: "Xem tất cả {n} trả lời",
    loadMore: "Tải thêm",
    allReplies: "Tất cả trả lời ({n})",
    commentDeleted: "Đánh giá này đã bị xóa",
    commentShielded: "Đánh giá này đã bị ẩn",
    replyDeleted: "Trả lời này đã bị xóa",
    replyShielded: "Trả lời này đã bị ẩn",
  },
  detail: {
    svipRequiredMsg: "Trò chơi này yêu cầu SVIP để chơi",
    timeInsufficientMsg: "Thời gian chơi không đủ, vui lòng mua thời gian chơi trước",
    goBuy: "Mua ngay",
    thinkAgain: "Suy nghĩ lại",
    navTitle: "Chi tiết game",
    back: "Quay lại",
    svipOnly: "Chỉ SVIP",
    vipOnly: "Chỉ VIP",
    freeMinutes: "Miễn phí {n} phút",
    saveManage: "Bản lưu",
    saveManageDesc: "Xem / khôi phục bản lưu cũ và thêm ghi chú",
    liveVideos: "Video gameplay",
    more: "Xem thêm",
    viewAll: "Xem tất cả",
    viewAllCount: "Xem tất cả {n}",
    intro: "Giới thiệu game",
    screenshots: "Ảnh chụp màn hình",
    controlMethod: "Điều khiển: ",
    playerReviews: "Đánh giá",
    commentCount: "{n}",
    recommend: "Đề xuất",
    notRecommend: "Không đề xuất",
    similarGames: "Game tương tự",
    collect: "Yêu thích",
    collected: "Đã yêu thích",
    collectStar: "☆ Yêu thích",
    collectedStar: "★ Đã yêu thích",
    unfavorited: "Đã xóa khỏi yêu thích",
    entering: "Đang vào…",
    unlockSvip: "Mở khóa bằng SVIP",
    unlockVip: "Mở khóa bằng VIP",
    startGame: "Chơi ngay",
    reviewCount: "{n} đánh giá",
    sortHot: "Nổi bật",
    sortNew: "Mới nhất",
    noMore: "Đã hết",
    playedHours: "Đã chơi {n} giờ",
    report: "Báo cáo",
    reportTitle: "Báo cáo bình luận này?",
    reportMessage: "Đội kiểm duyệt sẽ xem xét. Báo cáo chứ?",
    reported: "Đã báo cáo",
    noReviews: "Chưa có đánh giá — hãy là người đầu tiên",
    writeReview: "Viết đánh giá",
    reviewPlaceholder: "Chia sẻ trải nghiệm của bạn… (ít nhất 5 ký tự)",
    reviewMinLength: "Đánh giá phải có ít nhất 5 ký tự",
    reviewSubmitted: "Đã gửi đánh giá",
    publish: "Đăng",
    commentDetail: "Bình luận",
    replyCount: "{n} trả lời",
    noReplies: "Chưa có trả lời — hãy là người đầu tiên",
    reply: "Trả lời",
    replyToUser: "Trả lời {'@'}{name}",
    saySomething: "Viết gì đó…",
    send: "Gửi",
    sent: "Đã gửi",
    videoCount: "{n} video",
    watchCount: "{k}k lượt xem",
    noVideos: "Chưa có video",
    videoUnavailable: "Video này hiện không phát được",
    videoUnavailableDesc: "Có thể đây là clip cũ đã bị gỡ — hãy thử video khác",
  },
  search: {
    placeholder: "Nhập tên game",
    emptyHint: "Tìm theo tên game hoặc pinyin",
    history: "Tìm kiếm gần đây",
    clear: "Xóa",
    noResults: "Không tìm thấy game",
  },
  misc: {
    savesTitle: "Bản lưu game",
    savesTitleNamed: "{name} - Bản lưu",
    savesLoginPrompt: "Đăng nhập để xem bản lưu game của bạn",
    savesActiveHeading: "Bản lưu đang dùng",
    savesUnnamed: "Bản lưu chưa đặt tên",
    savesEditRemark: "Đổi tên",
    savesEmpty: "Chưa có bản lưu đám mây",
    savesEmptyHint: "Bản lưu trong game sẽ tự động đồng bộ tại đây",
    savesHistory: "Lịch sử",
    savesCount: "{n} bản lưu",
    savesCurrent: "Hiện tại",
    savesCorrupted: "Lỗi",
    savesRestore: "Khôi phục",
    savesNoHistory: "Không có lịch sử bản lưu",
    savesFooter:
      "Bản lưu được tạo khi bạn lưu thủ công / tự động trong game và tự động đồng bộ lên đám mây. Hiện chưa hỗ trợ xóa thủ công (tiếp tục lưu trong game sẽ ghi đè bản cũ nhất).",
    savesRemarkTitle: "Sửa ghi chú bản lưu",
    savesRemarkPlaceholder: "Đặt tên cho bản lưu này, ví dụ \"Hoàn thành Chương 1\"",
    savesSave: "Lưu",
    savesAlreadyCurrent: "Đây đã là bản lưu hiện tại",
    savesRestoreTitle: "Khôi phục bản lưu",
    savesRestoreConfirm:
      "Khôi phục về bản lưu này? Lần khởi động tới, game sẽ bắt đầu từ \"{name}\".",
    savesSwitched: "Đã chuyển sang bản lưu này",
    savesSaved: "Đã lưu",
    ctrlNavTitle: "Cài đặt tay cầm",
    ctrlSave: "Lưu",
    ctrlIntro:
      "Tinh chỉnh cảm giác chuột / tay cầm tại đây. Để trống / 0 sẽ dùng mặc định máy chủ của từng game; thay đổi áp dụng cho mọi game.",
    ctrlMouseSensitivity: "Độ nhạy chuột",
    ctrlServerDefault: "Mặc định máy chủ",
    ctrlMouseHint: "Ở chế độ khóa, khoảng cách di chuyển = di chuyển thực × {n}%",
    ctrlStickSensitivity: "Độ nhạy cần phải",
    ctrlStickHint:
      "Tốc độ xoay ngắm cho game FPS / hành động. Cần trái (di chuyển) không bị ảnh hưởng.",
    ctrlPrimaryClick: "Nút chuột chính",
    ctrlLeftPrimary: "Chuột trái chính",
    ctrlRightPrimary: "Chuột phải chính",
    ctrlPrimaryClickHint:
      "Một số game (như vài game indie) mặc định bắn bằng chuột phải và cần hoán đổi.",
    ctrlResetDefault: "Đặt lại",
    ctrlSavedToast: "Đã lưu, áp dụng ở lần khởi động tới",
    ctrlResetToast: "Đã khôi phục cấu hình máy chủ",
    savesUploading: "Đang tải lên bản lưu — vui lòng thử lại sau giây lát",
    savesCheckFailed: "Không kiểm tra được trạng thái bản lưu — vui lòng thử lại",
  },
  play: {
    stageReady: "Sẵn sàng",
    queueing: "Đang xếp hàng",
    queueJoining: "Đang vào hàng đợi…",
    queueAheadPrefix: "Còn ",
    queueAheadSuffix: "người trước bạn",
    queueEta: "khoảng {n}s",
    cancelReturn: "Hủy và quay lại",
    back: "Quay lại",
    retry: "Thử lại",
    goSubscribe: "Nâng cấp",
    entering: "Đang vào game",
    vipCta: "Nâng cấp VIP để vào ngay",
    vipPerks: "Miễn xếp hàng + chất lượng HD + chơi lâu hơn",
    sessionExpiredHint:
      "Phiên thường hết hạn sau khi chờ lâu — nhấn \"Thử lại\" để xếp hàng lại",
    lineOldUser: "Hàng đợi người chơi cũ",
    lineNewbie: "Hàng đợi người chơi mới",
    lineFast: "Hàng đợi tăng tốc",
    lineSvip: "Hàng đợi SVIP",
    svipRequired: "Game này chỉ dành cho SVIP. Vui lòng nâng cấp SVIP trước",
    stageConnectingServer: "Đang kết nối máy chủ…",
    stageHandshake: "Đang bắt tay với máy chủ…",
    stageP2pNegotiating: "Đang thiết lập kênh P2P…",
    stageMediaStreaming: "Đang truyền phát…",
    stageWaitingFrame: "Đang chờ hình ảnh…",
    stageVideoTrack: "Đã nhận luồng hình ảnh…",
    stageEntered: "Đã kết nối",
    stageConnect: "Kết nối",
    stageConnectedSoon: "Đã kết nối — hình ảnh sẽ hiện ngay…",
    allocFailed: "Không thể cấp phát máy chủ game",
    allocFailedHttp: "Cấp phát thất bại (HTTP {status})",
    reenterHint: " (vui lòng thoát và vào lại game)",
    errP2pFailed: "Thiết lập P2P thất bại. Vui lòng kiểm tra mạng",
    errDisconnected: "Mất kết nối (code={code}). Vui lòng thử lại",
    errStageFailed: "{stage} thất bại",
    errStageFailedDetail: "{stage} thất bại: {detail}",
    errConnectTimeout:
      "Hết thời gian kết nối — không thể tới máy chủ. Kiểm tra mạng và thử lại",
    errQueueCancelled: "Máy chủ đã hủy lượt xếp hàng của bạn. Vui lòng thử lại",
    errKicked:
      "Tài khoản của bạn đã đăng nhập trên thiết bị khác, nên phiên này bị ngắt kết nối",
    errCannotStart: "Hiện chưa thể bắt đầu game",
    registerFailed: "Đăng ký thất bại",
  },
  game: {
    recharge: "Nạp giờ",
    tabControl: "Điều khiển",
    tabFrame: "Hình ảnh",
    tabVoice: "Âm thanh",
    controlScheme: "Chế độ điều khiển",
    hideVirtualKeys: "Ẩn nút ảo",
    mouseMode: "Chế độ chuột",
    mouseModeTouchpad: "Bàn di",
    mouseModeDrag: "Kéo",
    mouseModeDirect: "Trực tiếp",
    mouseSensitivity: "Độ nhạy chuột {n}%",
    rightStickMode: "Chế độ cần phải",
    joyModeFixed: "Cố định",
    joyModeHalf: "Nửa màn hình",
    joyModeFull: "Toàn màn hình",
    joyModeDrag: "Kéo",
    stickSensitivity: "Độ nhạy cần {n}%",
    customLayout: "Bố cục nút tùy chỉnh",
    editLayout: "Sửa bố cục",
    frameComingSoon:
      "Tính năng thu phóng / đổi chất lượng hình ảnh sẽ có ở phiên bản sau.",
    gameSound: "Âm thanh game",
    schemeFollow: "Theo game",
    schemeGamepad: "Tay cầm",
    schemeKeyMouse: "Bàn phím & chuột",
    schemeTouch: "Cảm ứng",
    schemeSwitchedGamepad: "Đã chuyển sang tay cầm",
    schemeSwitchedKeyMouse: "Đã chuyển sang bàn phím & chuột",
    schemeSwitchedFollow: "Đã khôi phục theo game",
    modifierTitle: "Trình chỉnh sửa",
    modifierNeedUnlock: "Trình chỉnh sửa này cần mua để mở khóa",
    usageTitle: "Hướng dẫn",
    usageEmpty: "Chưa có hướng dẫn",
    gotIt: "Đã hiểu",
    close: "Đóng",
    noModifiers: "Không có trình chỉnh sửa",
    locked: "Đã khóa",
    needUnlock: "Mua để mở khóa",
    remaining: "Còn {d}",
    use: "Sử dụng",
    quitTitle: "Thoát game",
    quitConfirm: "Thoát game hiện tại?",
    quitConfirmBtn: "Thoát",
    quitCancelBtn: "Tiếp tục chơi",
    joyNameFixed: "Cố định",
    joyNameHalfZone: "Vùng nửa màn hình",
    joyNameFullFollow: "Theo toàn màn hình",
    joyNameDrag: "Kéo",
    padConnected: "🎮 Đã kết nối tay cầm, ẩn nút ảo",
    padDisconnected: "Tay cầm đã ngắt, khôi phục nút ảo",
    rightStickToast: "Cần phải: {name}",
    noEditableLayout: "Không có bố cục nút để chỉnh sửa",
    timeUsedUp: "Đã hết thời gian chơi",
    addTimeSuccess: "Đã thêm thời gian",
    submitted: "Đã gửi",
    minutesShort: "{n} phút",
    addTime: "Thêm thời gian",
    expand: "Mở rộng",
    collapse: "Thu gọn",
    physicalPadConnected: "Đã kết nối tay cầm vật lý",
    unmute: "Bật tiếng",
    mute: "Tắt tiếng",
    fullscreen: "Toàn màn hình",
    summonKeyboard: "Hiện bàn phím",
    sensoryMode: "Điều khiển chuyển động",
    idleWarnTip: "Không có hoạt động. Thoát khỏi trò chơi sau {n}s.",
    idleContinue: "Tiếp tục",
    nsInputTitle: "Trò chơi cần nhập văn bản",
    nsInputHint: "Nhập nội dung rồi xác nhận",
    settings: "Cài đặt",
    currentRemaining: "Còn {n} phút",
    exchangeBeans: "Đổi thời gian bằng token",
    useAddTimeCard: "Dùng thẻ thêm thời gian",
  },
  net: {
    requestFailed: "Yêu cầu thất bại",
    errorWithCode: "Lỗi {code}",
    serverError: "Lỗi máy chủ {status}",
    timeout: "Hết thời gian yêu cầu",
    networkError: "Lỗi mạng",
  },
  controls: {
    selectKeyFirst: "Hãy chọn một nút trước",
    saved: "Đã lưu",
    saveFailed: "Lưu thất bại",
    selected: "Đã chọn: {name}",
    keyFallback: "nút",
    hint: "Kéo để di chuyển; chạm để chỉnh kích thước / độ mờ / thao tác",
    size: "Kích thước {pct}%",
    opacity: "Độ mờ {pct}%",
    operation: "Thao tác",
    opPress: "Nhấn",
    opDrag: "Kéo",
    opLock: "Khóa",
    delete: "Xóa",
    addKey: "Thêm nút",
    reset: "Đặt lại",
    save: "Lưu",
    addHiddenKey: "Thêm nút ẩn",
    noHiddenKeys: "Không có nút ẩn",
  },
};

export default messages;
